/* eslint-disable no-undef */
import React from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { compose } from "redux";
import AuthService from "../services/AuthService";
import * as authAction from "../actions/auth";
import MasterService from "../services/MasterService";
import ToastService from '../services/ToastService';

const required = (value, name) => {
  if (!name.value) {
    return (
      <div className="isaerror" role="alert">
        Please enter your {name.name}
      </div>
    );
  }
};
class Registration extends React.Component {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
    this.handleRegistration = this.handleRegistration.bind(this);
    this.state = {
      username: '',
      password: '', confirmPassword: '', pwdValidation: [], setConfirmTouched: false, setPwdTouched: false,
      email: '', categories: [], tNc: false,
      selectedCountry: 0, selectedCategory: 0, nameError: '',
      emailError: '',
      countries: [], selectedRole: 0, roles: [
        // { id: 'co_admin', name: "Admin" },
        { id: 'Practitioners', name: "Practitioner" },
        { id: 'Mission Users', name: "Mission User" },
        { id: 'General Public', name: "Public User" },
        { id: 'Ayush Chairs', name: "Ayush Chairs" },
        { id: 'Association Users', name: "Association User" },
      ], authImage: []
    };

  }

  componentDidMount = () => {
    this.getAllCountries();
    this.getAuthImage();
  };

  getAuthImage = () => {
    AuthService.getAuthImage().then(result => {

      if (!result) return;
      const authImageLoc = [];


      result.data[0].images?.map((item, index) => (

        authImageLoc.push({
          'backgroundImage': `url(${item})`,
          'backgroundPosition': "center",
          'backgroundSize': "cover",
        })));
      this.setState({ authImage: authImageLoc })
    })
      .catch(err => {
        console.error(err);
      });
  }

  isValidpassword = (value, name) => {
    const { pwdValidation } = this.state;
    this.setState({ touchedPwd: name });
    const pwdPattern = new RegExp(/(?=.*?[A-Za-z])(?=.*?[0-9])(?=.*?[@$!%*#?~(&)+=^_-]).{8,}/);

    if (!pwdPattern.test(value) || value.length < 8) {
      pwdValidation[name] = (
        <div className="isaerror" role="alert">
         Password must be at least 8 characters long, include letters, numbers, & 1 special character.
        </div>
      );
    } else pwdValidation[name] = "";
    // } else { this.error = false; }
  };

  getAllCountries = () => {
    MasterService.getAyushCountries()
      .then(result => {
        if (!result) {
          return;
        }
        this.setState({ countries: result });
      })
      .catch(err => {
        console.error(err);
      });
  };

  getAllCategories = () => {
    MasterService.getCategories()
      .then((result) => {
        if (!result) {
          return;
        }
        this.setState({ categories: result });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  validateName = (value) => {
    const namePattern = /^[a-zA-Z\s]+$/; // Only allows alphabets and spaces
    if (!value) {
      this.setState({ nameError: 'Name is required' });
    } else if (!namePattern.test(value)) {
      this.setState({ nameError: 'Name should only contain alphabets and spaces' });
    } else {
      this.setState({ nameError: '' });
    }
  };

  validateEmail = (value) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!value) {
      this.setState({ emailError: 'Email is required' });
    } else if (!emailPattern.test(value)) {
      this.setState({ emailError: 'Invalid email format' });
    } else {
      this.setState({ emailError: '' });
    }
  };
  onSelectedCountry = (e) => {
    this.setState({ selectedCountry: e.target.value });
  };

  // handleRegistration = e => {
  //   e.preventDefault();
  //   const { username, password, selectedCountry, email, selectedCategory, selectedRole, tNc } = this.state;
  //   const data = {
  //     'user_login': username,
  //     'user_pass': password,
  //     'user_email': email,
  //     'blog_id': selectedCountry,
  //     'user_role': selectedRole,
  //     'user_category': selectedCategory
  //   };
  //   if (username && password && selectedCountry && email && tNc && ((selectedRole === 'Practitioners' ? selectedCategory : selectedRole)))
  //     AuthService.register(data)
  //       .then(result => {
  //         if (!result) {
  //           return;
  //         }
  //         if (result?.status === 200) {
  //           // this.props.userDetail(result);
  //           ToastService.success("Signed up successfully!");
  //           this.props.history.push({
  //             pathname: "/login",
  //           });
  //           // window.location.reload();
  //         } else {
  //           ToastService.error(result.data[0]);
  //         }
  //       })
  //       .catch(err => {
  //         console.error(err);
  //       });
  // };

  handleRegistration = e => {
    e.preventDefault();
    const { username, password, selectedCountry, email, selectedCategory, selectedRole, tNc } = this.state;
    this.validateName(username);
    this.validateEmail(email);
    // Username validation (no special characters)
    const usernameRegex = /^[a-zA-Z0-9]+$/;
    if (!usernameRegex.test(username)) {
      ToastService.error("Username should not contain special characters.");
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      ToastService.error("Please enter a valid email address.");
      return;
    }

    const data = {
      'user_login': username,
      'user_pass': password,
      'user_email': email,
      'blog_id': selectedCountry,
      'user_role': selectedRole,
      'user_category': selectedCategory
    };

    if (username && password && selectedCountry && email && tNc && ((selectedRole === 'Practitioners' ? selectedCategory : selectedRole))) {
      AuthService.register(data)
        .then(result => {
          if (!result) {
            return;
          }
          if (result?.status === 200) {
            ToastService.success("Signed up successfully!");
            this.props.history.push({
              pathname: "/login",
            });
          } else {
            ToastService.error(result.data[0]);
          }
        })
        .catch(err => {
          console.error(err);
        });
    } else {
      ToastService.error("Please fill in all required fields.");
    }
  };

  samePwdCheck = (password, confirmPwd) => {
    if (password === confirmPwd) this.setState({ pwdConfirm: " " });
    else
      this.setState({
        pwdConfirm: (
          <div className="isaerror" role="alert">
            Confirm password is not matched
          </div>
        ),
      });
  };

  onSelectedRole = (e) => {
    this.setState({ selectedRole: e.target.value });
    this.getAllCategories();
  };

  onSelectedCategory = (e) => {
    this.setState({ selectedCategory: [e.target.value] });
  };

  bgshapestyle = {
    clipPath: "polygon(0 0, 100% 0, 100% 71%, 0% 100%)",
    background: "#00A88A",
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    zIndex: "0",
    padding: "0 0 1rem 0",
  };

  innerform = {
    zIndex: "9",
    position: "inherit",
    padding: "40px 0",
  };

  loginbox = {
    // background: "#FFFFFF",
    // boxShadow: "6px 4px 21px rgba(0, 0, 0, 0.25)",
    // borderRadius: "20px",
    /* From https://css.glass */
    background: "rgb(255 255 255 / 83%)",
    borderRadius: "16px",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
    backdropFilter: "blur(10.4px)",
    WebkitBackdropFilter: "blur(10.4px)",
    border: "1px solid rgba(255, 255, 255, 0.28)",
  };

  normalhd = {
    fontStyle: "normal",
    fontWeight: "300",
    fontSize: "22px",
    lineHeight: "28px",
    color: "#000000",
    margin: "0",
  };

  colorhd = {
    fontStyle: "normal",
    fontWeight: "800",
    lineHeight: "28px",
    background: "linear-gradient(90deg, #F19755 5.81%, #00A88A 100%)",
    backgroundClip: "text",
    margin: "0",
    textFillColor: "transparent",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  };

  benefitGrid = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr 1fr",
    columnGap: "1rem",
    rowGap: "1rem",
    marginTop: "1rem",
    flexGrow: "1",
  };

  gridcell = {
    // border: '1px solid gray',
    // borderRadius: '10px',
    backgroundColor: "white",
    // boxShadow: "rgb(0 133 109) -10px -10px 15px, rgb(0 0 0 / 15%) 10px 10px 15px",
    /* From https://css.glass */
    background: "rgba(255, 255, 255, 0.33)",
    borderRadius: "16px",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
    backdropFilter: "blur(10.4px)",
    WebkitBackdropFilter: "blur(10.4px)",
    border: "1px solid rgba(255, 255, 255, 0.28)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    rowGap: "8px",
    justifyContent: "center",
    padding: "1rem",
    overflow: "clip",
  };



  render() {
    const { email, username, selectedCountry, countries, selectedRole, roles, confirmPassword, password, pwdValidation, pwdConfirm, touchedPwd, categories, selectedCategory, tNc, authImage, nameError, emailError } = this.state;

    return (
      <div style={{ position: "relative" }}>
        {/* below is the bg shape */}
        <div className="bgshape" style={this.bgshapestyle}></div>
        <div className="container" style={this.innerform}>
          <form
            className="formRegistration row"
            ref={c => {
              this.form = c;
            }}
            style={{ minHeight: "40vh", zIndex: "9" }}
          >
            {/* below is the left section containing the heading and paragraphs */}
            <div className="col-sm-7">
              <section
                style={{
                  width: "100%",
                  padding: "1rem",
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                <h2
                  style={{
                    color: "white",
                    fontSize: "40px",
                    fontWeight: "700",
                  }}
                >
                  Ayush Global Portal
                </h2>
                <p
                  style={{
                    color: "white",
                    fontSize: "14px",
                    textAlign: "justify",
                  }}
                >
                  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Cum,
                  beatae provident, quod suscipit a voluptatum vel odit,
                  eligendi dolores voluptate deleniti ab ullam perspiciatis!
                  Itaque voluptatum eveniet error dolore illo!
                </p>
                <h3
                  style={{
                    fontSize: "30px",
                    fontWeight: "700",
                    color: "#006755",
                    marginTop: "3rem",
                  }}
                >
                  Spreading Ayush across the globe.
                </h3>
                {/* our benefits grid below */}
                <div style={this.benefitGrid}>
                  {authImage.map((item, index) => <div key={index} style={(this.gridcell, item)}> </div>)}
                </div>
              </section>
            </div>
            {/* below is the right column containing the registration form */}
            <div className="col-sm-5">
              {/* below is the form */}
              <section style={this.loginbox}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      columnGap: "1rem",
                      minHeight: "40vh",
                      padding: "1.5rem",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {/* below is the registration heading logos section*/}
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        gap: "8px",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={require("../public/grid-logo-1.png")}
                        alt="Ayush grid logo"
                        style={{
                          flexGrow: "1",
                          width: "166px",
                          height: "63px",
                        }}
                      />
                      <div
                        style={{
                          width: "5px",
                          height: "51px",
                          background: "#F09755",
                          borderRadius: "20px",
                        }}
                      ></div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          flexGrow: "1",
                        }}
                      >
                        <p style={this.normalhd}>
                          Register with
                          <br />
                          <span style={this.colorhd}>Ayush Global Portal</span>
                        </p>
                      </div>
                    </div>
                    <p
                      style={{
                        fontStyle: "italic",
                        fontWeight: "500",
                        fontSize: "13px",
                        color: "#808080",
                        margin: "1rem 0.5rem",
                      }}
                    >
                      Enter your basic details below to get started
                    </p>
                    {/* below is the main registration fields */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "1rem",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          margin: "0 0.5rem",
                        }}
                      >
                        <label
                          htmlFor="username"
                          style={{
                            marginBottom: "0.25rem",
                            color: "#9e9e9e",
                            fontSize: "14px",
                          }}
                        >
                          Your Username
                        </label>
                        <input
                          type="username"
                          name="username"
                          id="username"
                          value={username}
                          onChange={e => {
                            this.setState({ username: e.target.value }); this.validateName(e.target.value);
                          }}
                          validations={[required]}
                          style={{
                            background: "#f8f8f8",
                            border: "2px solid #dddddd",
                            padding: "1rem",
                            borderRadius: "14px",
                          }}
                          placeholder="your username"
                          required=""
                        />
                        {nameError && (
                          <div className="isaerror" role="alert">{nameError}</div>
                        )}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          margin: "0 0.5rem",
                        }}
                      >
                        <label
                          htmlFor="email"
                          style={{
                            marginBottom: "0.25rem",
                            color: "#9e9e9e",
                            fontSize: "14px",
                          }}
                        >
                          Your email
                        </label>
                        <input
                          type="email"
                          name="email"
                          id="email"
                          value={email}
                          onChange={e => {
                            this.setState({ email: e.target.value });
                            this.validateEmail(e.target.value);
                          }}
                          validations={[required]}
                          style={{
                            background: "#f8f8f8",
                            border: "2px solid #dddddd",
                            padding: "1rem",
                            borderRadius: "14px",
                          }}
                          placeholder="name@company.com"
                          required=""
                        />{emailError && (
                          <div className="isaerror" role="alert">{emailError}</div>
                        )}
                      </div>
                      {/* <div style={{ display: 'flex', flexDirection: 'column', margin: '0 0.5rem' }}>
                        <label htmlFor="password"
                          style={{ marginBottom: '0.25rem', color: '#9e9e9e', fontSize: '14px' }}>Password</label>
                        <input type="password" name="password" id="password" style={{ background: '#f8f8f8', border: '2px solid #dddddd', padding: '1rem', borderRadius: '14px' }} placeholder="••••••••" value={password} onChange={(e) => this.setState({ password: e.target.value })} validations={[required]} />
                      </div> */}
                      {/* <div style={{ display: 'flex', flexDirection: 'column', margin: '0 0.5rem' }}>
                        <label htmlFor="confirm-password"
                          style={{ marginBottom: '0.25rem', color: '#9e9e9e', fontSize: '14px' }}>Confirm Password</label>
                        <input type="confirm-password" name="confirm-password" id="confirm-password" style={{ background: '#f8f8f8', border: '2px solid #dddddd', padding: '1rem', borderRadius: '14px' }} placeholder="••••••••" required="" />
                      </div> */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          margin: "0 0.5rem",
                        }}
                      >
                        <label
                          htmlFor="confirm-password"
                          style={{
                            marginBottom: "0.25rem",
                            color: "#9e9e9e",
                            fontSize: "14px",
                          }}
                        >
                          Select Country
                        </label>
                        <select style={{ background: '#f8f8f8', border: '2px solid #dddddd', padding: '1rem', borderRadius: '14px', }} name='orderby' className='form-control' aria-label='Shop order' value={selectedCountry}
                          onChange={(e) => this.onSelectedCountry(e)}>
                          <option value='' defaultValue='selected'>Countries</option>
                          {countries.map((item, index) => <option key={index} value={item.id}>{item.blogname}</option>)} </select>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          margin: "0 0.5rem",
                        }}
                      >
                        <label
                          htmlFor="password"
                          style={{
                            marginBottom: "0.25rem",
                            color: "#9e9e9e",
                            fontSize: "14px",
                          }}
                        >
                          Password
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          name="password"
                          minLength="8"
                          value={password}
                          onChange={e =>
                            this.setState({ password: e.target.value })
                          }
                          onBlur={e => (
                            this.setState({ setPwdTouched: true }),
                            this.isValidpassword(e.target.value, e.target.name)
                          )}
                        />
                        {touchedPwd === "password" && pwdValidation.password}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          margin: "0 0.5rem",
                        }}
                      >
                        <label
                          htmlFor="password"
                          style={{
                            marginBottom: "0.25rem",
                            color: "#9e9e9e",
                            fontSize: "14px",
                          }}
                        >
                          Confirm Password
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          name="confirmPassword"
                          minLength="8"
                          disabled={pwdValidation.password}
                          value={confirmPassword}
                          onChange={e =>
                            this.setState({ confirmPassword: e.target.value })
                          }
                          onBlur={e => (
                            this.setState({ setConfirmTouched: true }),
                            this.samePwdCheck(password, e.target.value),
                            this.isValidpassword(e.target.value, e.target.name)
                          )}
                        />
                        {touchedPwd === "confirmPassword" &&
                          (pwdValidation.confirmPassword || pwdConfirm)}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          margin: "0 0.5rem",
                        }}
                      >
                        <label
                          htmlFor="confirm-password"
                          style={{
                            marginBottom: "0.25rem",
                            color: "#9e9e9e",
                            fontSize: "14px",
                          }}
                        >
                          Select Role
                        </label>
                        <select style={{ background: '#f8f8f8', border: '2px solid #dddddd', padding: '1rem', borderRadius: '14px', }} name='orderby' className='form-control' aria-label='Shop order' value={selectedRole}
                          onChange={(e) => this.onSelectedRole(e)}>
                          <option value='' defaultValue='selected'>Roles</option>
                          {roles.map((item, index) => <option key={index} value={item.id}>{item.name}</option>)} </select>
                      </div>
                      {selectedRole === 'Practitioners' ? <div style={{ display: 'flex', flexDirection: 'column', margin: '0 0.5rem' }}>
                        <label htmlFor="confirm-password"
                          style={{ marginBottom: '0.25rem', color: '#9e9e9e', fontSize: '14px' }}>Select Category
                        </label>
                        <select style={{ background: '#f8f8f8', border: '2px solid #dddddd', padding: '1rem', borderRadius: '14px', }} name='orderby' className='form-control' aria-label='Shop order' value={selectedCategory}
                          onChange={(e) => this.onSelectedCategory(e)}>
                          <option value='' defaultValue='selected'>Category</option>
                          {categories?.map((item, index) => <option key={index} value={item.name}>{item.name}</option>)} </select>
                      </div> : ''}
                      <div style={{ display: 'flex', padding: '0 0.5rem', columnGap: '8px' }} >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <input id="terms" aria-describedby="terms" type="checkbox"
                            style={{ width: '1rem', height: '1rem', border: '2px solid grey', borderRadius: '4px' }}
                            value={tNc}
                            onClick={(e) => this.setState({ tNc: e.target.checked })}
                            checked={tNc}
                            required="" />
                        </div>
                        <div>
                          <label htmlFor="terms" style={{ color: "#868686" }}>
                            I accept the{" "}
                            <Link
                              style={{ color: "#00a78a", fontWeight: "500" }}
                              to="/term-condition"
                            >
                              Terms and Conditions
                            </Link>
                          </label>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          padding: "0 0.5rem",
                          rowGap: "8px",
                        }}
                      >
                        <button
                          type="submit"
                          onClick={e => this.handleRegistration(e)}
                          style={{
                            backgroundColor: "#007e67",
                            borderRadius: "14px",
                            border: "none",
                            padding: "1rem",
                            fontWeight: "600",
                            fontSize: "18px",
                            color: "white",
                          }}
                        >
                          Create an account
                        </button>
                        <p>
                          Already have an account?{" "}
                          <Link to="/login">Login here</Link>
                        </p>
                      </div>
                    </div>
                    {/* registration form end */}
                  </div>
                </div>
              </section>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return { translation: state.translation };
};
const mapDispatchToProps = dispatch => {
  return {
    userDetail: user => dispatch(authAction.userDetail(user)),
  };
};
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
)(Registration);
